import { cn } from '@/lib/utils';

/**
 * Marque DocInfoPro.
 *
 * Le sigle est un SVG inline plutôt qu'une image : pas de requête réseau, une
 * couleur qui suit le thème, et un rendu net à toutes les résolutions.
 */
export function Logo({ className, inverted = false }: { className?: string; inverted?: boolean }) {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <svg
                viewBox="0 0 32 32"
                className="size-8 shrink-0"
                role="img"
                aria-label="DocInfoPro"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="32" height="32" rx="8" className={inverted ? 'fill-white' : 'fill-brand-600'} />
                {/* Une page de registre, stylisée : trois lignes et un sceau. */}
                <path
                    d="M9 10.5h9M9 15h14M9 19.5h11"
                    strokeWidth="2"
                    strokeLinecap="round"
                    className={inverted ? 'stroke-brand-600' : 'stroke-white'}
                />
                <circle cx="22.5" cy="21.5" r="3" className={inverted ? 'fill-accent-600' : 'fill-accent-500'} />
            </svg>

            <span
                className={cn(
                    'font-display text-xl leading-none tracking-tight',
                    inverted ? 'text-white' : 'text-ink',
                )}
            >
                DocInfoPro
            </span>
        </span>
    );
}
